import { Observable } from "rxjs";
import { UseCase } from "../../../base/usecases";
import { TypeSearchingBy } from "../../model/TypeSearchingBy";
import { SearchRepository } from "../../repositories/search/search.repository";
import { SearchEnrollmentDto } from "src/app/data/repositories/search/dto/search-enrollment.dto";
import { Metadata } from "src/app/base/model/data-body-request";
import { ProcessedDataResponse } from "src/app/base/model/processed-data-response";

export class SearchEnrollmentUseCase implements UseCase<{}, ProcessedDataResponse<SearchEnrollmentDto>> {
    constructor(private searchRepository: SearchRepository) { }
    execute(
        params: {
            dataToSearch: string,
            typeSearchingBy: TypeSearchingBy,
            metadata: Metadata,
        },
    ): Observable<ProcessedDataResponse<SearchEnrollmentDto>> {
        return this.searchRepository.searchEnrollment(params);
    }
}